import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../misc/Card";
import { PlatformIcon } from "../../utils/logo-getter";
import { AnalyticsCount } from "../../types/analytics";

interface BreakdownListProps {
    title: string;
    rows: AnalyticsCount[];
    labelOf: (key: string) => string;
    showPlatformIcon?: boolean;
    emptyText: string;
}

const BreakdownList: React.FC<BreakdownListProps> = ({
    title,
    rows,
    labelOf,
    showPlatformIcon = false,
    emptyText,
}) => {
    const max = rows.reduce((m, r) => Math.max(m, r.count), 0);
    return (
        <Card className="mt-0">
            <CardHeader className="pb-2">
                <CardTitle className="text-left text-base">{title}</CardTitle>
            </CardHeader>
            <CardContent>
                {rows.length === 0 ? (
                    <p className="text-sm text-gray-500">{emptyText}</p>
                ) : (
                    <ul className="space-y-3">
                        {rows.map((row) => (
                            <li key={row.key} className="flex items-center gap-3">
                                {showPlatformIcon && (
                                    <span className="w-6 h-6 shrink-0">
                                        <PlatformIcon platform={row.key} className="w-6 h-6" />
                                    </span>
                                )}
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between text-sm">
                                        <span className="truncate text-primary font-medium">{labelOf(row.key)}</span>
                                        <span className="ml-2 font-semibold text-primary">{row.count}</span>
                                    </div>
                                    <div className="mt-1 h-2 w-full rounded bg-gray-200">
                                        <div
                                            className="h-2 rounded bg-secondary"
                                            style={{ width: `${max ? Math.round((row.count / max) * 100) : 0}%` }}
                                        />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </CardContent>
        </Card>
    );
};

export default BreakdownList;
